export const getStations = (companies) => {
  const stations = [];

  companies.forEach((company) =>
    stations.push(
      ...company.stations.map((station) => ({
        ...station,
        label: station.name,
        value: station.id,
        company: company.name,
      }))
    )
  );
  return stations.sort((station, nextStation) =>
    station.name.localeCompare(nextStation.name)
  );
};

export const orderCompaniesAndStations = (companies = []) => {
  const orderedCompanies = companies
    .map((company) => {
      return {
        ...company,
        label: company.name,
        value: company.id,
        stations: company.stations.sort((station, nextStation) =>
          station.name.localeCompare(nextStation.name)
        ),
      };
    })
    .sort((company, nextCompany) =>
      company.name.localeCompare(nextCompany.name)
    );

  return orderedCompanies;
};
